import React from 'react';
import { Drawer } from '@mui/material';

const DSDrawer = (props: React.ComponentProps<typeof Drawer>) => {
  return <Drawer {...props} />;
};

export default DSDrawer;
